var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossedEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52015 5.93407L1.39315 2.80807L2.80815 1.39307L22.6072 21.1931L21.1922 22.6071L17.8822 19.2971C16.1234 20.4126 14.0829 21.0034 12.0002 21.0001C6.60815 21.0001 2.12215 17.1201 1.18115 12.0001C1.61118 9.67078 2.78178 7.54296 4.52015 5.93407ZM14.7572 16.1721L13.2932 14.7081C12.7332 14.976 12.1039 15.0636 11.4921 14.9589C10.8802 14.8541 10.316 14.5621 9.87702 14.1232C9.43809 13.6843 9.14612 13.12 9.04137 12.5081C8.93662 11.8963 9.02424 11.267 9.29215 10.7071L7.82815 9.24307C7.19187 10.2046 6.90742 11.3564 7.02298 12.5036C7.13854 13.6507 7.647 14.7227 8.46227 15.5379C9.27754 16.3532 10.3495 16.8617 11.4967 16.9772C12.6438 17.0928 13.7957 16.8084 14.7572 16.1721ZM7.97415 3.76007C9.22115 3.27007 10.5802 3.00007 12.0002 3.00007C17.3922 3.00007 21.8782 6.88007 22.8192 12.0001C22.5127 13.6658 21.824 15.2376 20.8072 16.5921L16.9472 12.7321C17.0618 11.9597 16.994 11.1712 16.7491 10.4297C16.5042 9.68827 16.089 9.01448 15.5369 8.46233C14.9847 7.91019 14.311 7.49504 13.5695 7.25014C12.828 7.00524 12.0395 6.93741 11.2672 7.05207L7.97415 3.76007Z",
    fill: "#CCCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedEyeIcon);
export default __webpack_public_path__ + "static/media/CrossedEyeIcon.b683eb60219a7dfa374cf92ffcabbc6d.svg";
export { ForwardRef as ReactComponent };